import { render } from "./assistSizeModel.vue?vue&type=template&id=b09e344c"
import script from "./assistSizeModel.vue?vue&type=script&lang=js"
export * from "./assistSizeModel.vue?vue&type=script&lang=js"

import "./assistSizeModel.vue?vue&type=style&index=0&id=b09e344c&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__